module.exports = __webpack_public_path__ + "img/coding.013663a9.png";